/**
 * bb-sort-select.js
 * Custom BB sort disclosure → hidden <select id="SortBy"> → FacetFiltersForm AJAX.
 *
 * Key fixes vs previous version:
 *  1. Event delegation on document — survives FacetFiltersForm AJAX re-rendering
 *     of .sorting innerHTML (renderAdditionalElements replaces the element, not
 *     just its content, so direct listeners on #SortByDisclosure are orphaned).
 *  2. Dispatches 'input' not 'change' — FacetFiltersForm listens for 'input'.
 *  3. No DOM label/checkmark updates — after AJAX, Shopify re-renders the
 *     disclosure from Liquid with the correct current sort already reflected.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-sort-option');
    if (!btn) return;

    e.preventDefault();

    var select = document.getElementById('SortBy');
    if (!select) return;

    var value = btn.dataset.sortValue;
    if (!value) return;

    // Close the disclosure immediately
    var disclosure = btn.closest('details');
    if (disclosure) disclosure.removeAttribute('open');

    // No-op if already selected
    if (value === select.value) return;

    // Update the hidden select — FormData will serialize this for AJAX
    select.value = value;

    // 'input' is what FacetFiltersForm.debouncedOnSubmit listens for
    select.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
